import { Row, Col } from 'react-bootstrap';
import { FieldWrapper, RadioFieldGroup } from 'components/form';
import { QuestionnaireNextButton } from 'components/questionnaire-next-button';
import { QuestionnaireBackButton } from 'components/questionnaire-back-button';
import { InfoBox } from 'components/info-box';

import { QuestionContainer, QuestionContainerWhite, QuestionNumber } from '../../../components/styles';
import { useFormContext } from 'react-hook-form';

import questions from '../../../utils/MOT-questions-answers.json';
import popupTextData from '../../../utils/midlife-mot-info-pop-up-text.json';

export const QuestionThree = () => {
    const { data } = popupTextData;
    const popupText = data.find(item => item.question === 'wellbeing_question3');

    const { data: questionsData } = questions;
    const question = questionsData.find(item => item.question === '3');

    const options = questionsData.map((item: any) => {
        const options = [];
        for (let i = 1; i <= 5; i++) {
            const label = item[`answerValue${i}`];
            const value = item[`answerLabel${i}`];
            if (label && value) {
                options.push({ label, value });
            }
        }
        return options.reverse();
    });

    const {
        control,
        formState: { dirtyFields },
    } = useFormContext();

    return (
        <>
            <QuestionContainer>
                <Row>
                    <Col>
                        <QuestionNumber>Question 3 of 18</QuestionNumber>
                    </Col>
                </Row>
            </QuestionContainer>
            <QuestionContainerWhite>
                <QuestionContainer>
                    <Row>
                        <Col>
                            <FieldWrapper label={question!.questionText}>
                                <InfoBox content={popupText!.QuestionInfoButtonText} />
                                <RadioFieldGroup stacked name="wellbeing3" options={options[2]} />
                            </FieldWrapper>

                            <Row className="justify-content-between flex-column flex-md-row" style={{ marginTop: 25 }}>
                                <QuestionnaireBackButton route={'/question-two'} />
                                <QuestionnaireNextButton
                                    defaultValue={control._defaultValues.wellbeing3}
                                    dirtyFields={dirtyFields.wellbeing3}
                                    route={'/question-four'}
                                />
                            </Row>
                        </Col>
                    </Row>
                </QuestionContainer>
            </QuestionContainerWhite>
        </>
    );
};
